<template lang="pug">
  div(:class="$style.root")
    header(:class="$style.header")
      div(:class="$style.headerTitle") {{ header }}
    div(:class="$style.content")
      div(:class="$style.formGroup")
        label(:class="$style.labelInput") {{ $t('T_TO_WHOM') }}:
        ui-input(
          :disabled="true"
          :value="customer"
          :class="$style.input")
      div(:class="$style.formGroup")
        label(:class="[$style.labelInput, $style.required]") {{ $t('T_TOPIC') }}:
        ui-input(
          :value="description"
          :class="$style.input"
          :placeholder="$t('T_TOPIC_FILL')"
          :error="subjectError"
          @input.native="onSubjectChange")
        div(:class="$style.error", v-if="subjectError") {{ subjectError }}
      div(:class="$style.formGroup")
        label(:class="[$style.label, $style.required]") {{ $t('T_REQUEST_TYPE') }}:
        v-select(
          hide-details
          :items="availableRequestTypes"
          item-text="name"
          item-value="id"
          return-object
          v-model="selectedRequestType"
          :menu-props="{ zIndex: 10009 }"
          :class="$style.select"
          :no-data-text="$t('T_NO_AVAILABLE_REQUEST_TYPES')")
    div(:class="$style.actionButtons")
      ui-button(colored="green", @click.native="onSave") {{ $t('T_CREATE') }}
      ui-button(colored="red", @click.native="onCancel") {{ $t('T_CANCEL') }}
</template>

<script>
import { mapActions } from 'vuex';
import { toast } from 'src/utils';

export default {
  name: 'ModalCreateEmailActivity',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      header: this.value.header,
      customer: this.value.customer || '',
      description: this.value.description || '',
      currentRequestType: this.value.currentRequestType || null,
      requestTypesByTeam: this.value.requestTypesByTeam || [],
      selectedRequestType: null,
      subjectError: '',
      previousActivityId: this.value.previousActivityId || null,
    };
  },
  created() {
    this.selectedRequestType = this.requestTypesByTeam.find(
      (rt) => rt.id === this.currentRequestType,
    ) || null;
  },
  watch: {
    selectedRequestType(newVal) {
      if (newVal) {
        this.currentRequestType = newVal.id;
      } else {
        this.currentRequestType = null;
      }
    },
  },
  computed: {
    availableRequestTypes() {
      return this.requestTypesByTeam.map((rt) => ({
        id: rt.id,
        name: rt.name,
      }));
    },
  },
  methods: {
    ...mapActions('activities', ['createOutboundActivityByOperator']),
    onSubjectChange(e) {
      this.description = e.target.value;
      if (this.subjectError) {
        this.subjectError = '';
      }
    },
    onSave() {
      if (!this.description || !this.description.trim()) {
        this.subjectError = this.$t('T_TOPIC_FILL');
        return;
      }
      this.createOutboundActivityByOperator({
        previousActivityId: this.previousActivityId,
        subject: this.description,
        requestTypeId: this.selectedRequestType.id,
      })
        .then(() => {
          toast.success({ msg: this.$t('T_OUTGOING_EMAIL_ACTIVITY_CREATED') });
          this.$parent.close([null]);
        })
        .catch((error) => {
          toast.error({
            msg: this.$t('T_ERROR_CREATING_EMAIL_ACTIVITY')`: ${error.message || error}`,
          });
        });
    },

    onCancel() {
      this.$parent.close([null]);
    },
  },
};
</script>

<style lang="sass" module>
.root
  display: flex
  flex-direction: column
  width: 600px
  max-width: 90vw
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
.headerTitle
  font-size: 18px
  text-align: center
.content
  display: flex
  flex-direction: column
  padding: 24px
  min-width: 532px
  height: 386px
  flex: 1 1 100%
.formGroup
  margin-bottom: 18px
.labelInput
  display: block
  font-size: 16px
  margin-bottom: 12px
.label
  display: block
  font-size: 16px
  margin-bottom: -8px
.input
  width: 100%
  font-size: 16px
.error
  color: $color_red
  font-size: 12px
.select
  width: 100%
.actionButtons
  display: flex
  justify-content: space-around
  padding: 16px
.required
  &::after
    content: "*"
    color: $color_red
</style>
